module.exports = __webpack_public_path__ + "static/6321-14179b7eef2121930856828dbb0ef2d8.png";